<template>
    <div class="product_info">
      <section class="porduct-box">
         <el-carousel :interval="7200" direction="vertical" arrow="always" style="height: 100%;">
            <el-carousel-item class="pro-item-box bg-p-70">
              <h2 class="small">H5影像浏览器</h2>
              <span>影像数据移动化应用：院内院外、无处不在<br></span>
              <div class="pro-detail"><b>全网级影像调阅应用 ｜</b>云影像平台支持DICOM3.0标准的H5方式影像调阅，无需安装、即开即用，可实现任意位置、任何时间、多种终端、多平台、超大并发的影像调阅，实现医学影像的全院区、医联体、通网即可用的影像服务。 <br></div>
            </el-carousel-item>
            <el-carousel-item class="pro-item-box" style="background: #67C23A88">
              <h2 class="small">数字胶片</h2>
                <span>为“碳达峰、碳中和”的目标实现作出积极的贡献<br></span>
              <div class="pro-detail"><b>云胶片应用 ｜</b> 就诊患者可以通过公众号、小程序、二维码及短信链接等入口方式，通过手机、PAD、电脑各种终端不限时间、不限地点地畅享数字影像查询、下载和分享等服务。支持DICOM、JPG、BMP、PNG等类型图像的显示，以及调窗、缩放、移动、旋转、测量、播放等常规DICOM图像处理功能。 <br></div>
            </el-carousel-item>
            <el-carousel-item class="pro-item-box" style="background: #409EFF">
              <h2 class="small">医联体远程影像诊断与会诊平台</h2>
                <span>专家影像诊断工作站<br></span>
              <div class="pro-detail"><b>远程影像诊断（会诊）平台 ｜</b> 诊断（会诊）专家可以在任意位置、任何时间通过互联网安全认证进行远程影像会诊。支持影像会诊报告的书写、发布，支持报告模板功能。
通过远程诊断，让有限的医疗资源下沉到基层为医疗资源均质化，起到重要作用。
 <br></div>
                


            </el-carousel-item>
            <el-carousel-item class="pro-item-box" style="background: #67C23A88">
              <h2 class="small">影像大数据可视化平台</h2>
                <span>医技数据可视化、智能化、移动化进聚合与展现<br></span>
              <div class="pro-detail"><b>影像大数据可视化平台 ｜</b>超过80%的医疗数据来自于医学影像，约80%的临床问题需要影像检查才能得到准确的诊断结果，使得影像大数据具有很高的医学分析和指导价值。影像大数据集成平台将非结构化与半结构化的医技数据可视化、智能化、移动化进聚合与展现，实现医疗健康数据的一体化展现和挖掘。<br></div>               
            </el-carousel-item>
          </el-carousel>
      </section>
    </div>
</template>
<script>
export default {
  name: "productInfo",
  data() {
    return {
    //   src1:  require('./images/ios_android.png'),
    // src2:  require('./images/film_compare.png'),
    };  
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.imgzoIndex .product_info {
    height: 100%;
}
.imgzoIndex .product_info .porduct-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin-bottom: 8px;
    background: #fff;
}
.imgzoIndex .product_info .product-box .pro-item-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
  color: var(--WhiteColor-1);
}
.imgzoIndex .product_info .pro-item-box .pro-detail {
    padding: 32px;
    box-sizing: border-box;
    line-height: 160%;
}

</style>